import {
  InlineDataProps,
  InlineDataService,
  InlineDataServiceParams,
} from '@stripe-internal/inline-data';
import {Period} from './ProgrammableThermostatSample';

const wait = async (duration: number): Promise<void> => {
  await new Promise((resolve) => {
    setTimeout(resolve, duration);
  });
};

export const defaultTemps: Record<Period, number> = {
  Morning: 68,
  Afternoon: 72,
  Evening: 65,
  Night: 62,
};

export const defaultMerchantNameInput = 'Acme Inc.';

export const newMockService = (
  inlineData: InlineDataProps,
  {
    temps = {...defaultTemps},
    merchantName = defaultMerchantNameInput,
    delay = 0,
  }: {
    temps?: Record<Period, number>;
    merchantName?: string;
    delay?: number;
  } = {},
): InlineDataService => {
  return {
    fetch: async (params: InlineDataServiceParams) => {
      const {data: paramsData} = params;
      const results = inlineData.data.map((datum) => {
        if (
          datum.name &&
          datum.name === 'programmable-thermostat-sample-datum'
        ) {
          const datumValue = (datum.value as Record<string, unknown>) || {};
          const period = paramsData.period as Period;
          const temp = temps[period];
          return {
            ...datum,
            value: {
              ...datumValue,
              period,
              desired_temp: temp,
              merchant_name: merchantName,
            },
          };
        }
        return {...datum};
      });

      return wait(delay).then(() => {
        return {code: 200, type: 'success', data: results};
      });
    },
    action: async (params: InlineDataServiceParams) => {
      const {data: paramsData} = params;
      const results = inlineData.data.map((datum) => {
        if (
          datum.name &&
          datum.name === 'programmable-thermostat-sample-datum'
        ) {
          const datumValue = (datum.value as Record<string, unknown>) || {};
          const period = paramsData.period as Period;
          const delta = paramsData.delta as number;

          const temp = temps[period];
          const newTemp = temp + delta;
          temps[period] = newTemp;
          return {
            ...datum,
            value: {
              ...datumValue,
              period,
              desired_temp: newTemp,
              merchant_name: merchantName,
            },
          };
        }

        return {...datum};
      });

      return wait(delay).then(() => {
        return {code: 200, type: 'success', data: results};
      });
    },
  };
};
